module.exports = __webpack_public_path__ + "static/media/many-cameras.d5b910a3.jpg";